/* Native form submission remains available when JavaScript is disabled. */
if (!customElements.get('meta-ads-checkout')) {
  customElements.define('meta-ads-checkout', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const english = this.dataset.language === 'en';
      const form = this.querySelector('form');
      const button = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[role="status"]');
      const variant = form.elements.namedItem('id');

      variant.addEventListener('change', () => {
        const price = form.querySelector('[data-cta-label] [data-price]');
        if (price && variant.selectedOptions) {
          const formatted = variant.selectedOptions[0].dataset.price;
          const whole = price.querySelector('[data-price-whole]');
          if (whole) {
            const parts = formatted.split('.');
            whole.textContent = parts.length === 2 ? parts[0] : formatted;
            let decimal = price.querySelector('[data-price-decimal]');
            if (parts.length === 2) {
              if (!decimal) {
                decimal = document.createElement('span');
                decimal.className = 'mc-price-decimal';
                decimal.setAttribute('data-price-decimal', '');
                price.append(decimal);
              }
              decimal.textContent = '.' + parts[1];
            } else {
              decimal?.remove();
            }
          } else {
            price.textContent = formatted;
          }
        }
        status.hidden = true;
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (this.pending || button.disabled) return;
        this.pending = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.hidden = false;
        status.textContent = english ? 'Adding your course and opening checkout…' : 'جارٍ إضافة الدورة والانتقال إلى الدفع…';
        const variantId = variant.value;
        // Keep the displayed selection stable while the request is in flight.
        variant.disabled = true;
        try {
          const response = await fetch(`${form.action}.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
          if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            throw new Error(typeof error.description === 'string' ? error.description : (english ? 'Could not add the course. Please try again.' : 'تعذرت إضافة الدورة. حاول مرة أخرى.'));
          }
          window.location.assign(form.dataset.checkoutUrl);
        } catch (error) {
          status.textContent = error instanceof TypeError
            ? (english ? 'Connection failed. Check your connection and cart before trying again.' : 'تعذر الاتصال. تحقق من اتصالك ومن سلة التسوق قبل المحاولة مجدداً.')
            : error.message;
          button.disabled = false;
          variant.disabled = false;
          button.removeAttribute('aria-busy');
          this.pending = false;
        }
      });
    }
  });
}
